import { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'

export default function ClarifyPage({
  user,
  onConvertToTask,
  onConvertToProject,
  onConvertToRecurring
}) {
  const [inboxItems, setInboxItems] =
    useState([])

  useEffect(() => {
    fetchInboxItems()
  }, [])

  async function fetchInboxItems() {
    const { data, error } = await supabase
      .from('inbox')
      .select(`
        id,
        user_id,
        name,
        notes,
        created_at
      `)
      .is('processed_at', null)
      .is('deleted_at', null)
      .eq('user_id', user.id)
      .order('created_at', {
        ascending: true
      })

    if (error) {
      console.error(error)
      return
    }

    setInboxItems(data || [])
  }

  async function deleteInboxItem(id) {
    await supabase
        .from('inbox')
        .update({
        deleted_at: new Date().toISOString()
        })
        .eq('id', id)

    fetchInboxItems()
    }

  return (
    <div className="page-shell">
      <h1>Clarify</h1>

      <p>
        Decide what each captured item actually is.
      </p>

      {inboxItems.length === 0 ? (
        <p>Inbox clear. Nothing to clarify.</p>
      ) : (
        <div className="clarify-list">

          {inboxItems.map(item => (
            <div
              key={item.id}
              className="clarify-card"
            >
              <h3>{item.name}</h3>

              {item.notes && (
                <p>{item.notes}</p>
              )}

              <div className="clarify-actions">
                <button onClick={() =>
                onConvertToTask(item)
                }>
                Task
                </button>

                <button onClick={() =>
                onConvertToProject(item)
                }>
                Project
                </button>

                <button onClick={() =>
                onConvertToRecurring(item)
                }>
                Recurring
                </button>

                <button onClick={() =>
                deleteInboxItem(item.id)
                }>
                Delete
                </button>

              </div>
            </div>
          ))}

        </div>
      )}
    </div>
  )
}